import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { motion } from 'framer-motion';
import { PROVEEDORES_DATA, CALENDLY_URL } from '@/data/mock';
import { SectionHeading, FeatureCard, CTAButton } from '@/components/shared/SharedComponents';
import { Users, Building2, TrendingUp, ShieldCheck, BarChart3, Handshake } from 'lucide-react';

const iconMap = { Users, Building2, TrendingUp, ShieldCheck, BarChart3, Handshake };

export default function ProveedoresPage() {
  const { currentTheme: t, theme } = useTheme();

  return (
    <div style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* Hero */}
      <section className="pt-28 lg:pt-36 pb-16 lg:pb-24" style={{ background: t.heroBg }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl lg:text-5xl font-bold mb-6" style={{ color: t.text, fontFamily: 'Manrope, sans-serif' }}>
                {PROVEEDORES_DATA.hero.heading}
              </motion.h1>
              <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-lg mb-8" style={{ color: t.textSecondary }}>
                {PROVEEDORES_DATA.hero.subtitle}
              </motion.p>
              <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
                <CTAButton text="Quiero ser proveedor" href={CALENDLY_URL} />
              </motion.div>
            </div>
            <motion.div initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 }}>
              <img src={PROVEEDORES_DATA.hero.image} alt="Proveedores Motivy" className="w-full rounded-xl shadow-2xl" loading="lazy" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16 lg:py-24" style={{ background: t.bg }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading heading="¿Por qué ser proveedor de Motivy?" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {PROVEEDORES_DATA.benefits.map((b, i) => {
              const Icon = iconMap[b.icon];
              return <FeatureCard key={i} icon={Icon} title={b.title} description={b.description} index={i} />;
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16" style={{ background: t.sectionAltBg }}>
        <div className="max-w-3xl mx-auto text-center px-4">
          <h2 className="text-3xl font-bold mb-6" style={{ color: t.text, fontFamily: 'Manrope, sans-serif' }}>¿Listo para unirte?</h2>
          <CTAButton text="Quiero ser proveedor" href={CALENDLY_URL} />
        </div>
      </section>
    </div>
  );
}
